<template>
  <PageTemplate :loading="loading">
    <v-container v-if="!loading" class="pt-10 pb-12">
      <Title v-if="title">{{ title }}</Title>

      <v-row v-if="items.length" class="mt-6 mt-sm-8">
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-for="(item, keyItems) in items"
          :key="keyItems"
        >
          <TeamCard :item="item" />
        </v-col>
        <v-col v-if="pagesLength > 1" class="mt-10" cols="12">
          <v-pagination v-model="page" :length="pagesLength"></v-pagination>
        </v-col>
      </v-row>

      <v-alert v-else type="warning" class="mt-10">
        Nenhum item adicionado até o momento.
      </v-alert>
    </v-container>
  </PageTemplate>
</template>

<script>
import { formatToURL } from "../../utils/formatToURL";
import PageTemplate from "../templates/Page.vue";
import Title from "../widgets/Title.vue";
import TeamCard from "../cards/Team.vue";

const _config = {
  mod: "team",
};

export default {
  data: () => ({
    loading: true,
    items: [],
    itemsPerPage: 24,
    totalItems: 0,
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    specialties() {
      return this.$rest("specialties").list.map(({ id, title }) => ({
        id,
        title,
        uri: `${formatToURL(title)}-${id}`,
      }));
    },
    filterSpecialties() {
      if (!this.$route.params.item) return "";

      return this.specialties.filter(
        (specialties) => specialties.uri === this.$route.params.item
      )[0];
    },
    title() {
      if (this.filterSpecialties) return this.filterSpecialties.title;

      return "";
    },
  },
  created() {
    this.$rest("specialties").get();

    this.get();
  },
  watch: {
    itemId() {
      this.get();
    },
    $route() {
      this.get();
    },
    page() {
      this.get();
    },
  },
  methods: {
    get() {
      const params = {
        itemsPerPage: this.itemsPerPage,
        returnTotalItems: 1,
      };

      if (this.itemId) params.category = this.itemId;
      if (this.page) params.page = this.page;

      this.loading = true;

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, { totalItems, list }) => {
            this.items = list.map(
              ({ img, title, office, specialty, text }) => ({
                img,
                title,
                office,
                specialty: specialty.title ? specialty.title : "",
                text,
              })
            );
            this.totalItems = totalItems;

            if (!list.length && this.page > 1) this.page = 1;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  components: {
    PageTemplate,
    Title,
    TeamCard,
  },
};
</script>
